/**
 * @author Fernando Tapia <ftapia@pensare.mx>
 * @version 1.0.0
 * @file Method to get information from service monthly recovery
 */

import {URL_SERVER} from '../../utils/constants.js';

/**
 * Function to generalize the fetch request information.
 * @param serviceURL
 * @returns {Promise<Response>}
 */
export function getFetch(serviceURL) {
  var headers = new Headers();
  headers.append("Authorization", sessionStorage.getItem('token'));

  return fetch(URL_SERVER + serviceURL, {method: "get", headers: headers})
    .then(response => {
      if (response.status === 200) {
        return response.json()
      }
      else if (response.status === 401) {
        return (window.location="/");
      }
      else {
        return []
      }
    })
    .then(json => {
      return json
    });
}

export function postFetch(serviceURL, params) {
  var headers = new Headers();
  headers.append('Authorization', sessionStorage.getItem('token'));
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');
  return fetch(URL_SERVER + serviceURL, {method: "post", headers: headers, body: JSON.stringify(params)})
    .then(response => {
      if (response.status === 200) {
        return response.json()
      }
      else if (response.status === 401) {
        return (window.location="/");
      }
      else {
        return []
      }
    })
    .then(json => {
      return json
    });
}

export function getFetch2(serviceURL) {
  var headers = new Headers();
  headers.append("Authorization", sessionStorage.getItem('token'));

  return fetch(URL_SERVER + serviceURL, {method: "get", headers: headers})
    .then(response => {
      if (response.status === 200) {
        return response.text()
      }
      else if (response.status === 401) {
        return (window.location="/");
      }
      else {
        return []
      }
    })
    .then(obj => {
      return obj
    });
}

export function postFetch2(serviceURL, params) {
  var headers = new Headers();
  headers.append('Authorization', sessionStorage.getItem('token'));

  return fetch(URL_SERVER + serviceURL, {method: "post", headers: headers, body: (params)})
    .then(response => {
      if (response.status === 200) {
        return response.json()
      }
      else if (response.status === 401) {
        return (window.location="/");
      }
      else {
        return []
      }
    })
    .then(json => {
      return json
    });
}

export function postFetch3(serviceURL, params) {
  var headers = new Headers();
  headers.append('Authorization', sessionStorage.getItem('token'));
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  return fetch(URL_SERVER + serviceURL, {method: "post", headers: headers, body: JSON.stringify(params)})
    .then(response => {
      if (response.status === 200) {
        return response
      }
      else if (response.status === 401) {
        return (window.location="/");
      }
      else {
        return []
      }
    })
    .then(json => {
      return json
    });
}

export function deleteFetch(serviceURL, params) {
  const headers = new Headers();
  headers.append('Authorization', sessionStorage.getItem('token'));
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  return fetch(URL_SERVER + serviceURL, { method: 'delete', headers, body: JSON.stringify(params) })
    .then((response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        return (window.location = '/');
      }
      return [];
    })
    .then(json => json);
}

export function putFetch(serviceURL, params) {
  const headers = new Headers();
  headers.append('Authorization', sessionStorage.getItem('token'));
  headers.append('Accept', 'application/json');
  headers.append('Content-Type', 'application/json');

  return fetch(URL_SERVER + serviceURL, { method: 'put', headers, body: JSON.stringify(params) })
    .then((response) => {
      if (response.status === 200) {
        return response;
      } else if (response.status === 401) {
        return (window.location = '/');
      }
      return [];
    })
    .then(json => json);
}



// WEBPACK FOOTER //
// ./src/service/data-info-chart/requestsUtil.js